import { render, staticRenderFns } from "./MultiText.vue?vue&type=template&id=72ae0ed2"
import script from "./MultiText.vue?vue&type=script&lang=js"
export * from "./MultiText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports